



















import {Vue, Prop, Watch, Component} from 'vue-property-decorator'
import Destination from '../models/Destination';
import PassengerDestination from '../models/PassengerDestination';
@Component({})
export default class PassengerDestinationPicker extends Vue {
    
  selected: Destination | null = null;

  @Prop({default: null}) private value: PassengerDestination;
  @Prop({ default: false }) private disabled: boolean;
  
  @Watch('value', { immediate: true })
  valueChanged() {
    if (this.value) {
      const target = this.destinations.find(d => d.id === this.value.destinationId);
      this.selected = target;
    }
  }

  @Watch('selected')
    selectItem() {
      const toParent = new PassengerDestination(0, this.selected.id);
      this.$emit('input', toParent)
    }

  get destinations(): Destination[] {
    return this.$store.state.destination.destinations as Destination[];
  }

}
